export default {"src":"/_next/static/media/shade.60136665.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};